import { IWarehouseInitialState } from "../../../types/master/warehouseInterface";
import { WarehouseActionTypes, WarehouseActions } from "../../actionTypes/master/warehouseActionTypes";

const initialState: IWarehouseInitialState = {
  warehouseList: [],
  warehouseData: {
    id: 0,
    warehouse_name: "",
    email: "",
    pincode: 0,
    contact_person: "",
    contact_number: "",
    pickup_address: "",
    return_address: "",
    customer_id: 0,
    pickup_hours: {},
    pickup_days: [],
    business_days: [],
    business_hours: {},
    customer: {
      id: 0,
      company_name: "",
    },
    wareHouse_pincode: {
      id: 0,
      pincode: 0,
      district_id: 0,
      cod: false,
      pre_paid: false,
      cash: false,
      pickup: "",
      delivery: "",
      branch_id: 0,
      franchise_id: 0,
      district: {
        id: 0,
        district_name: "",
        state: {
          id: 0,
          state_name: "",
        },
      },
    },
  },
  warehouseListPageCount: 0,
};

export default function warehouseReducer(state = initialState, action: WarehouseActionTypes): IWarehouseInitialState {
  switch (action.type) {
    case WarehouseActions.SET_WAREHOUSE_LIST:
      return {
        ...state,
        warehouseList: action.payload,
      };

    case WarehouseActions.SET_WAREHOUSE_LIST_PAGE_COUNT:
      return {
        ...state,
        warehouseListPageCount: action.payload,
      };

    case WarehouseActions.SET_WAREHOUSE_DATA_BY_ID:
      return {
        ...state,
        warehouseData: action.payload,
      };

    default:
      return state;
  }
}
